<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs required">{{ $t('productCategory.code') }}</label>
        <input v-model="model.category_code" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('category_code') }" :readonly="isUpdate" />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('category_code')">{{ errors.first('category_code') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('productCategory.nameKh') }}</label>
        <input v-model="model.category_name_kh" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('category_name_kh') }" />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('category_name_kh')">{{
          errors.first('category_name_kh') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('productCategory.nameEn') }}</label>
        <input v-model="model.category_name_en" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('category_name_en') }" />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('category_name_en')">{{
          errors.first('category_name_en') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('productCategory.icon') }}</label>
        <input v-model="model.icon" type="text" class="form-control" :class="{ 'is-invalid': errors.has('icon') }" />
        <small><i><a href="https://fontawesome.com/v4.7/icons/" target="_blank">{{ $t('productGroup.findYourIcon')
              }}</a></i></small>
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('icon')">{{ errors.first('icon') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('productCategory.account') }}</label>
        <a-select v-model="model.account_id" :options="coaSetupOptions" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('account_id') }" :placeholder="$t('select')"
          :loading="loading" allowClear></a-select>
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('account_id')">{{ errors.first('account_id') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('productCategory.purchaseAccount') }}</label>
        <a-select v-model="model.purchase_account_id" :options="coaSetupOptions" show-search
          option-filter-prop="children" class="ts-w-full" :class="{ 'is-invalid': errors.has('purchase_account_id') }"
          :placeholder="$t('select')" :loading="loading" allowClear></a-select>
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('purchase_account_id')">{{
          errors.first('purchase_account_id') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
            $t('cancel')
          }}
        </ts-button>
        <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave" :waiting="waiting">{{ $t('save')
        }}</ts-button>
        <ts-button v-if="isUpdate" color="primary" @click.prevent="onUpdate" :waiting="waiting">{{ $t('update')
        }}</ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"> </Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'productCategoryForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      loading: false,
      model: {
        category_id: 0,
        category_code: null,
        category_name_kh: null,
        category_name_en: null,
        icon: null,
        account_id: null,
        purchase_account_id: null
      }
    }
  },
  created() {
    this.fetchResource()
  },
  computed: {
    ...mapState('product/productCategory', ['edit_data', 'formViewDatas']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    coaSetupOptions() {
      if (this.formViewDatas['coaSetups']) {
        return this.formViewDatas['coaSetups'].map(el => ({
          value: el.account_id,
          label: `${el.account_number} - ${el.account_name_en}${el.currency ? ' | ' + el.currency.currency_code : ''}`
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('product/productCategory', ['getFormViewModel']),
    async fetchResource() {
      this.loading = true
      await this.getFormViewModel({
        index: undefined,
        params: {}
      })
        .then(() => {
          this.setEditData()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('product/productCategory/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('product/productCategory/update', {
          id: this.model.category_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.category_id = this.edit_data.category_id
        this.model.category_code = this.edit_data.category_code
        this.model.category_name_kh = this.edit_data.category_name_kh
        this.model.category_name_en = this.edit_data.category_name_en
        this.model.icon = this.edit_data.icon
        this.model.account_id = this.edit_data.account_id
        this.model.purchase_account_id = this.edit_data.purchase_account_id
      }
    }
  }
}
</script>
